import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { Typography, Box, Chip } from "@mui/material";
import moment from "jalali-moment";
import { ListOfStatusGlobal } from "../../../../interface/enum/StatusGlobal";

/**
 * تعریف ستون‌های DataGrid برای گزارش کارکرد
 */
export const workHistoryColumns: GridColDef[] = [
  {
    field: "createdOn",
    headerName: "تاریخ",
    minWidth: 150,
    renderCell: (params) => (
      <Typography variant="body2">
        {moment(params.value).format("jYYYY/jMM/jDD HH:mm")}
      </Typography>
    ),
  },
  {
    field: "taskTitle",
    headerName: "وظیفه/پیگیری",
    minWidth: 200,
    renderCell: (params) => {
      const taskTitle = params.row.taskTitle;
      const followupTitle = params.row.followupTitle;

      if (taskTitle) {
        return (
          <Typography
            variant="body2"
            color="primary"
            sx={{ fontWeight: "bold" }}
          >
            وظیفه: {taskTitle}
          </Typography>
        );
      } else if (followupTitle) {
        return (
          <Typography
            variant="body2"
            color="secondary"
            sx={{ fontWeight: "bold" }}
          >
            پیگیری: {followupTitle}
          </Typography>
        );
      } else {
        return (
          <Typography variant="body2" color="text.secondary">
            نامشخص
          </Typography>
        );
      }
    },
  },
  {
    field: "customerInfo",
    headerName: "مشتری/شرکت",
    minWidth: 180,
    renderCell: (params) => {
      const customerName = params.row.customerName;
      const companyName = params.row.companyName;

      if (!customerName && !companyName) {
        return (
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
        );
      }

      return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {customerName && (
            <Typography variant="body2" color="primary">
              {customerName}
            </Typography>
          )}
          {companyName && (
            <Typography variant="caption" color="text.secondary">
              {companyName}
            </Typography>
          )}
        </Box>
      );
    },
  },
  {
    field: "statusTask",
    headerName: "وضعیت",
    minWidth: 120,
    renderCell: (params) => {
      const status = ListOfStatusGlobal.find((s) => s.value === params.value);
      return (
        <Chip
          label={status?.label || "نامشخص"}
          color={status?.color as any}
          variant="filled"
          size="small"
        />
      );
    },
  },
  {
    field: "statusDesc",
    headerName: "توضیحات",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "isArchived",
    headerName: "وضعیت رکورد",
    minWidth: 120,
    renderCell: (params) => (
      <Chip
        label={params.value ? "آرشیو شده" : "فعال"}
        color={params.value ? "default" : "success"}
        variant="outlined"
        size="small"
      />
    ),
  },
];
